var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"harmonogram--empty d-flex flex-row align-stretch"},[_vm._v(" "+_vm._s(_vm.noVacancy)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }